import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tenantsService, TenantProfileUpdate } from '@/services/tenants';
import { useAuthStore } from '@/context/authStore';
import { Tenant } from '@/types';
import toast from 'react-hot-toast';

export function useTenantProfile() {
  return useQuery({
    queryKey: ['tenant-profile'],
    queryFn: tenantsService.getProfile,
  });
}

export function useUpdateTenantProfile() {
  const queryClient = useQueryClient();
  const setTenant = useAuthStore((state) => state.setTenant);

  return useMutation({
    mutationFn: (data: TenantProfileUpdate) => tenantsService.updateProfile(data),
    onSuccess: (updatedTenant: Tenant) => {
      // Actualizar el query cache
      queryClient.invalidateQueries({ queryKey: ['tenant-profile'] });
      // Actualizar el store global para que el sidebar se actualice
      setTenant(updatedTenant);
      toast.success('Perfil actualizado correctamente');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Error al actualizar el perfil');
    },
  });
}

export function useUploadTenantLogo() {
  const queryClient = useQueryClient();
  const setTenant = useAuthStore((state) => state.setTenant);

  return useMutation({
    mutationFn: (file: File) => tenantsService.uploadLogo(file),
    onSuccess: (updatedTenant: Tenant) => {
      // Actualizar el query cache
      queryClient.invalidateQueries({ queryKey: ['tenant-profile'] });
      // Actualizar el store global para que el sidebar se actualice
      setTenant(updatedTenant);
      toast.success('Logo actualizado correctamente');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Error al subir el logo');
    },
  });
}

export function useDeleteTenantLogo() {
  const queryClient = useQueryClient();
  const setTenant = useAuthStore((state) => state.setTenant);

  return useMutation({
    mutationFn: tenantsService.deleteLogo,
    onSuccess: (updatedTenant: Tenant) => {
      // Actualizar el query cache
      queryClient.invalidateQueries({ queryKey: ['tenant-profile'] });
      // Actualizar el store global para que el sidebar se actualice
      setTenant(updatedTenant);
      toast.success('Logo eliminado');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Error al eliminar el logo');
    },
  });
}
